<template>
  <div id="text">
    
  </div>
</template>

<script>
export default {
  name: 'Temp',
  data: function(){
      return {

      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Temp.vue